import { mf, msg } from '../message-functions'

/**
  <span style="color:#85c1dc;">**EE:**</span>
  Tagasi poodi

  <span style="color:#85c1dc;">**FI:**</span>
  Jatka ostoksia

  <span style="color:#85c1dc;">**RU:**</span>
  Продолжить покупки
*/
/* @__NO_SIDE_EFFECTS__ */
const m1482 = msg(
  mf`Tagasi poodi`,
  mf`Jatka ostoksia`,
  mf`Продолжить покупки`,
)

export { m1482 as 'w.module.product_modal.continue_shopping' }